import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_MUTATION = gql`
  mutation saveLocationTypesAndLocationTypeCategories(
    $data: [LocationTypeCategoryNodeInput!]!
  ) {
    saveLocationTypesAndLocationTypeCategories(data: $data) {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
`

export default SAVE_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_MUTATION
